import { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { useSettings } from './providers/SettingsProvider';
import { AppRouting } from './routing';
import { PathnameProvider } from './providers';
import { useHealthCheckPolling } from './hooks/useHealthCheckPolling';
import SkipToContent from './components/SkipToContent';
import { setNavigate } from './utils/navigate';

const NavigateSetter = () => {
  const navigate = useNavigate();
  useEffect(() => { setNavigate(navigate); }, [navigate]);
  return null;
};

const { BASE_URL } = import.meta.env;

const App = () => {
  const { settings } = useSettings();
  useHealthCheckPolling();

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.remove('light');
    document.documentElement.classList.remove('contrast');
    document.documentElement.classList.add(settings.themeMode);
  }, [settings]);

  return (
    <BrowserRouter basename={BASE_URL}>
      <NavigateSetter />
      <SkipToContent />
      <PathnameProvider>
        <AppRouting />
      </PathnameProvider>
    </BrowserRouter>
  );
};

export { App };
